import { Group, Paper, type PaperProps } from "@mantine/core"
import type { TActivityBase } from "@/types"
import { stringToColor } from "@/utils"
import { ActivityIcon } from "../utils"

export function ActivityImagePlaceholder({
  activity: { title, type },
  h = 120,
  ...props
}: PaperProps & { activity: TActivityBase; h?: any }) {
  return (
    <Paper h={h} c="white" radius={0} bg={stringToColor(title, 7)} {...props}>
      <Group h="100%" justify="flex-end" pr="md">
        <ActivityIcon type={type} size={h / 1.42} opacity={0.77} />
      </Group>
    </Paper>
  )
}
